<div
  class="skills"
  [class.skills--editable]="isEditable"
  [class.skills--compact]="compact"
  cdkDropList
  cdkDropListOrientation="mixed"
  [cdkDropListDisabled]="!isEditable"
  (cdkDropListDropped)="onDrop($event)"
>
  @for (skill of skills; track skill.name ? skill.name : skill.userProvidedText; let i = $index) {
    <div
      class="skill-chip"
      [class.skill-chip--editable]="isEditable"
      [class.skill-chip--removable]="removable"
      [class.skill-chip--compact]="compact"
      [class.skill-chip--moderation]="!skill.name && !isEditable"
      cdkDrag
      [cdkDragDisabled]="!isEditable"
    >
      @if (isEditable) {
        <svg-icon
          src="/assets/icons/drag-dots.svg"
          class="skill-chip__handle"
          cdkDragHandle
        ></svg-icon>
      }
      <span class="skill-chip__name">{{ skill.name ? skill.name : skill.userProvidedText   }}</span>
      @if (isEditable || removable) {
        <svg-icon
          src="/assets/icons/skill-remove.svg"
          class="skill-chip__remove"
          (click)="onRemove(i)"
        ></svg-icon>
      }
      <div
        class="skill-chip skill-chip--editable skill-chip--placeholder"
        *cdkDragPlaceholder
      ></div>
    </div>
  }
</div>
